import React from 'react';
import PropTypes from 'prop-types';
import { Card, Divider, Text } from '@stashinvest/react-components';
import { BanjoString } from '@stashinvest/react-banjo';
import {
	FREQUENCY_UNIT_MONTH,
	FREQUENCY_UNIT_YEAR,
} from 'stash/constants/platformTierTypes';
import { getFormattedDateString, parseDate } from 'stash/utils';
import { hasGreaterThanZeroValue } from '../reactivation/tier-selection/utils';

/**
 * Displays the next billing period for the user's subscription.
 */
export const PlanDetailsCard = ({ className, billingSummary }) => {
	if (!billingSummary) return null;
	if (
		!hasGreaterThanZeroValue(
			billingSummary.currentBillingPeriod?.billingFrequency?.amount
		)
	) {
		return null;
	}
	const planName = billingSummary.name;
	const planCost = parseInt(
		billingSummary.nextBillingPeriod?.billingFrequency?.amount?.value || 0
	);
	const billingFrequency =
		billingSummary.nextBillingPeriod?.billingFrequency?.frequency?.unit;
	const dueDate = billingSummary.nextChargeDate;
	const displayPlanCost = `$${planCost} ${
		billingFrequency === FREQUENCY_UNIT_MONTH
			? 'monthly'
			: billingFrequency === FREQUENCY_UNIT_YEAR
			? 'yearly'
			: ''
	}`;
	return (
		<Card className={className}>
			<div className="flex justify-between items-center mb-contentSmall">
				<Text textStyle="labelXSEmphasize">PLAN DETAILS</Text>
			</div>
			<Divider className="mb-contentSmall" />
			<div className="flex justify-between items-center my-contentSmall">
				<Text textStyle="bodyMediumStandard" tag="label">
					{planName}
				</Text>
				<Text textStyle="bodyMediumEmphasize">{displayPlanCost}</Text>
			</div>
			<div className="flex justify-between items-center mb-contentSmall">
				<Text textStyle="bodyMediumStandard" tag="label" maxLines="1">
					<BanjoString stringId="management/property/nextPayDate" />
				</Text>
				<Text textStyle="bodyMediumEmphasize">
					{dueDate && getFormattedDateString(parseDate(dueDate), `PP`)}
				</Text>
			</div>
		</Card>
	);
};

PlanDetailsCard.propTypes = {
	className: PropTypes.string,
	billingSummary: PropTypes.object,
};
